/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/js-cookie@2.2.1/src/js.cookie.js
 * 
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function t(o){function r(){}function i(n,t,i){if("undefined"!=typeof document){"number"==typeof(i=e({path:"/"},r.defaults,i)).expires&&(i.expires=new Date(1*new Date+864e5*i.expires)),i.expires=i.expires?i.expires.toUTCString():"";try{var c=JSON.stringify(t);/^[\{\[]/.test(c)&&(t=c)}catch(e){}t=o.write?o.write(t,n):encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var f="";for(var u in i)i[u]&&(f+="; "+u,!0!==i[u]&&(f+="="+i[u].split(";")[0]));return document.cookie=n+"="+t+f}}function c(e,t){if("undefined"!=typeof document){for(var r={},i=document.cookie?document.cookie.split("; "):[],c=0;c<i.length;c++){var f=i[c].split("="),u=f.slice(1).join("=");t||'"'!==u.charAt(0)||(u=u.slice(1,-1));try{var a=n(f[0]);if(u=(o.read||o)(u,a)||n(u),t)try{u=JSON.parse(u)}catch(e){}if(r[a]=u,e===a)break}catch(e){}}return e?r[e]:r}}return r.set=i,r.get=function(e){return c(e,!1)},r.getJSON=function(e){return c(e,!0)},r.remove=function(n,t){i(n,"",e(t,{expires:-1}))},r.defaults={},r.withConverter=t,r}(function(){})});

///////////////////////////////////////////////////////////////////////////////////
//  Js


$(function(){
    
    // sp pc switch
    var replaceWidth = 768;

    (function () {
        var $setElem = $('.switch'),
            pcName   = '_pc',
            spName   = '_sp';

        $setElem.each(function () {
            var $this = $(this);
            function imgSize() {
                var winWidth = window.innerWidth;
                if (winWidth != 'undefind') {
                    if (winWidth <= replaceWidth) {
                        $this.attr('src', $this.attr('src').replace(pcName, spName));
                    } else {
                        $this.attr('src', $this.attr('src').replace(spName, pcName));
                    }
                }
            }
            $(window)
                .on('resize', function () {
                    imgSize();
                });
            imgSize();
        });
    })();
	
	// gloval navigation 
	$('#menuButton').on('click', function() {
		if($(this).hasClass('is-active')){
			$(this).removeClass('is-active');
			$('#header').removeClass('is-active');
			$('.glonav').removeClass('is-active');
			$('.header__inner__navi .r-nav').removeClass('is-active');
			$(".glonav__inner__list .r-box").removeClass('scrollin');
			$(".glonav__inner__banner .r-list").removeClass('scrollin');
            $('body').removeClass('is-menu');
		} else {
			$(this).addClass('is-active');
			$('#header').addClass('is-active');
			$('.glonav').addClass('is-active');
			$('.header__inner__navi .r-nav').addClass('is-active');
			setTimeout(function(){
				$(".glonav__inner__list .r-brand").addClass('scrollin');
			},300);
			setTimeout(function(){
				$(".glonav__inner__list .r-menu").addClass('scrollin');
			},400);
			setTimeout(function(){
				$(".glonav__inner__list .r-category").addClass('scrollin');
			},500);
			setTimeout(function(){
				$(".glonav__inner__list .r-feature").addClass('scrollin');
			},600);
			setTimeout(function(){
				$(".glonav__inner__list .r-official").addClass('scrollin');
			},700);
			setTimeout(function(){
				$(".glonav__inner__list .r-info").addClass('scrollin');
			},800);
			setTimeout(function(){
				$(".glonav__inner__list .r-magazine").addClass('scrollin');
			},900);
			setTimeout(function(){
				$(".glonav__inner__list .r-sns").addClass('scrollin');
			},1000);
			setTimeout(function(){
				$(".glonav__inner__banner .r-banner").addClass('scrollin');
			},1100);
            $('body').addClass('is-menu');
		}
	});
    
    // slider
    if ($('#mainvisual').length) {

        $('#mainvisual > ul').bxSlider({
            default: true,
            auto: true,
            infiniteLoop: true,
            randomStart: false,
            speed: 1500,
            pause: 7000,
            onSlideBefore: function(e) {
                $($(e[0]).find('.lazy')).each(function(index,value){
                    var $target = $(value);
                    $target.attr('src', $target.data('src'));
                    $target.removeClass('lazy');
                });
            }
        });
        $(document).on('mousedown','.bx-viewport a',function(){
            var $this = $(this),
            myHref = $this.attr('href'),
            myTarget = $this.attr('target');
            if(myTarget === '_blank'){
                window.open(myHref);
            }else{
                window.location.href = myHref;
            }
        });
        $(window).on('load resize', function(){
            var heightSize = $(window).height();
            $("#mainvisual .bx-viewport").height(heightSize - 60);
            $(".mainvisual_slider > li").height(heightSize - 60);
        });
    }
	
	
	// search
	$('.r-iconList .search').on('click', function() {
		$("#SearchModal").addClass('is-active');
	});
	$('#SearchModal #searchClose').on('click', function() {
		$("#SearchModal").removeClass('is-active');
	});
	
	// single tab
	$('.product-single__description .tab li').on('click', function() {
		$('.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        $('.is-show').removeClass('is-show');
		var index = $(this).index();
		$('.tab_content .box').eq(index).addClass('is-show');
    });
	
    if(document.cookie.indexOf('lfyt=1') > -1) {
		$('body').addClass('is-lfyt');
	} else {
        $('#openingLfyt svg').addClass('active');
            setTimeout(function(){
                $('body').addClass('is-lfyt');
                Cookies.set('lfyt', '1', { expires: 1 });
            },3000);
	}
	
	
	if($('#topBanner').length){
		$(window).on('scroll', function() {
			$("#topBanner .r-list > li ").each(function(){
				var imgPos = $(this).offset().top;    
				var scroll = $(window).scrollTop();
				var windowHeight = $(window).height();
				if (scroll > imgPos - windowHeight + windowHeight/5){
					$(this).addClass('scrollin');
				} else {
					$(this).removeClass('scrollin');
				}
			});
		});
	}
    

    $(".ht-tms--float").appendTo(".glonav__inner");
    
    
    if ($('.product-single__meta--wrapper').length) {
        $(window).on('load resize', function(){
            var widthBpx = $('.product-single__meta--wrapper').width();
            $(".product-single__meta").css("width",widthBpx);
            var widthHpx = $('.product-single__meta').height();
            $(".product-single__photos").css("min-height",widthHpx);
        });
    }
    
    if ($('.product-single__meta').length) {
        $(document).ready(function(){
            $(window).on("scroll", function() {
                
                var scrollHeight = $(document).height();
                var scrollPosition = $(window).height() + $(window).scrollTop();
                var footHeight = $("#shopify-section-footer").innerHeight();
                var wdjtHeight = $(".rk-widget-container").innerHeight();
                var num = $('.rk-widget-container').length;
                var stop = footHeight + (wdjtHeight*num)
                if ( scrollHeight - scrollPosition  <= stop ) { 
                    $(".product-single__meta").addClass('is-stop');
                } else {
                    $(".product-single__meta").removeClass('is-stop');
                }
            });
        });  
    }
     // wish list
    var wishFnc = function() {
        // list
        $('#swym-notepad-header #notepad-title').text('お気に入りリスト');
        $('#swym-notepad-header .swym-tag').remove();
        $('#swym-notepad-header').css('height','50px');
        $('#swym-item-grid > .swym-item').each(function(){
            var priceP = $(this).find('.swym-price').text();
            priceP = priceP.replace('.00','');
            $(this).find('.swym-price').text(priceP);
            var cartBtn = $(this).find('.swym-add-to-cart a');
            var cartTxt = '';
            if($(this).find('.swym-add-to-cart a:contains("Sold out")').length){
                cartTxt = cartBtn.text();
                cartTxt = cartTxt.replace('Sold out','out of stock');
                cartBtn.text(cartTxt);
            } else if($(this).find('.swym-add-to-cart a:contains("Add To Cart")').length){
                cartTxt = cartBtn.text();
                cartTxt = cartTxt.replace('Add To Cart', 'カートに入れる');
                cartBtn.text(cartTxt);
            } else if($(this).find('.swym-add-to-cart a:contains("Added")').length){
                cartTxt = cartBtn.text();
                cartTxt = cartTxt.replace('Added', 'カートに入っています');
                cartBtn.text(cartTxt);
            }
        });
    };
    var wishFnc02 = function() {
        // detail
        $('#swym-product-view-swiper .animate .swym-product-li').each(function(){
            var priceP02 = $(this).find('.swym-price').text();
            priceP02 = priceP02.replace('.00', '');
            $(this).find('.swym-price').text(priceP02);
            var cartBtn02 = $(this).find('.swym-button');
            var cartTxt02 = '';
            if($(this).find('.swym-button:contains("Sold out")').length){
                cartTxt02 = cartBtn02.text();
                cartTxt02 = cartTxt02.replace('Sold out','out of stock');
                cartBtn02.text(cartTxt02);
            } else {
                cartTxt02 = cartBtn02.text();
                cartTxt02 = cartTxt02.replace('Add To Cart', 'カートに入れる');
                cartBtn02.text(cartTxt02);
            }
            
        });
    };
    
    var langJp = $('html').attr('lang');
    
    if(langJp == 'ja') {
        
        wishFnc();
    
        $(window).on('load', function(){
            var target = document.getElementById('swym-plugin');
            var observer = new MutationObserver(records => {
                setTimeout(function(){
                    wishFnc();
                    wishFnc02();
                },400);
            });
            observer.observe(target, {
                attributes: true,
                childList: true
            });
        });
        $(document).on('click', '#swym-product-pagination > a', function (){
            setTimeout(function(){
                wishFnc02();
            },10);
        });
        $(document).on('change', '#swym-product-view-swiper .swym-select', function (){
            setTimeout(function(){
                wishFnc02();
            },10);
        });
    }

    // cart coming soonボタン無効

    setTimeout(function(){
        if($('.template-product').length && $('button:contains("Coming soon..")').length){
            $('#AddToCartForm--product-template').css('display','none');
        }
    },500); 
    setTimeout(function(){
        if($('.template-product').length && $('button:contains("Coming soon..")').length){
            $('#AddToCartForm--product-template').css('display','none');
        }
    },1000);  
    setTimeout(function(){
        if($('.template-product').length && $('button:contains("Coming soon..")').length){
            $('#AddToCartForm--product-template').remove();
            $('.product-single__policies').append('<p class="comingsoon" style="margin-top:30px;">COMING SOON...</p>');
        }
    },1500);

});
